import debug from "debug";

const log = debug("location-marker");
class LocationMarker {
	constructor({ id, lat, lng, type, isHighlighted, resultItem, templateEl, label, popoverContent }) {
		this.type = type;

		// Note all atm and branch markers are highlighted while all-locations is out of scope
		this.isHighlighted = isHighlighted;
		this.resultItem = resultItem;
		this.id = id;
		this.lat = lat;
		this.lng = lng;
		this.state = "idle";
		this.contentEl = this.generateMarkerContent(templateEl, label);
        this.popoverContent = popoverContent;
	}

	setMarkerIcons(markerIcon) {
		this.markerIcon = markerIcon;
	}

	setMarker(marker) {
		this.marker = marker;
	}

	generateMarkerContent(templateEl, label) {
		const content = templateEl.content.cloneNode(true);
		if(label) {
			content.querySelectorAll("[data-label]").forEach(el => el.textContent = label);
		}
		content.querySelector('.map-marker').classList.add(`map-marker--${this.type}`);
		return content;

	}

	getMarkerOptions(Point) {
		this.updateIconImage(this.getIdleIcon());
		return {
			position: { lat: this.lat, lng: this.lng },
			content: this.contentEl,
			gmpClickable: this.type != "search",
		};
	}

	// this is required as initializing the AdvancedMarkerElement causes the document fragment created in generateMarkerContent to become empty.
	updateContentEl(markerContentEl) {
		this.contentEl = markerContentEl;
	}

	// this logic is redundant while all-locations is in scope
	getIdleIcon() {
		return this.markerIcon[this.type][
			this.isHighlighted ? "highlight" : "default"
		];
	}

	getHoverIcon() {
		return this.markerIcon[this.type]["hover"];
	}

	getSelectIcon() {
		return this.markerIcon[this.type]["selected"];
	}

	getWidth() {
		return this.markerIcon[this.type]["width"];
	}

	getHeight() {
		return this.markerIcon[this.type]["height"];
	}

	hoverMarker() {
		if(this.getHoverIcon()) {
			this.updateIconImage(this.getHoverIcon());
		}
	}

	unhoverMarker() {
		this.updateIconImage(this.getIdleIcon());
	}

	selectMarker() {
		this.state = "selected";
		this.updateIconImage(this.getSelectIcon());
	}

	deselectMarker() {
		this.state = "idle";
		this.updateIconImage(this.getIdleIcon());
	}

	updateIconImage(iconPath) {
		this.contentEl.querySelectorAll("[data-icon]").forEach(el => el.src = iconPath);
	}

	onMarkerMouseIn() {
		if (this.state === "selected") {
			return false;
		}
		const hoverIcon = this.getHoverIcon();
		if(hoverIcon) {
			this.updateIconImage(hoverIcon);
		}
		if(this.resultItem) {
			this.resultItem.highlight();
		}
	}

	onMarkerMouseOut() {
		if (this.state === "selected") {
			return false;
		}
		this.updateIconImage(this.getIdleIcon());
		if(this.resultItem) {
			this.resultItem.unhighlight();
		}

	}
}

export default LocationMarker;



// WEBPACK FOOTER //
// ./project/client/src/core/modules/store-locator-map/location-marker.js